import { Component, ViewChild, OnInit } from '@angular/core';
import { AppBodyComponent } from './app-body/app-body.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  @ViewChild(AppBodyComponent) child: AppBodyComponent;
  title = 'app';

  public formatDetails(e) {
    // console.log('child event', e);
    this.child.getFormatDataFromApp(e);
  }

  public formatSizeDetails(e) {
    // console.log('child event', e);
    this.child.getFormatDetailsFromApp(e);
  }

  ngOnInit() {

    //avoid autoscroll on reload
    // window.onload = function(){
    //   window.scrollTo(0,0);
    // }

    // to get json data in local variables when the page load
    window.onscroll = function(){
      document.getElementById('typeahead-template').style.display = 'none';
      if(window.scrollY==0){
        document.getElementById('typeahead-template').style.display = 'inline';
      }
    }

    document.getElementById('closemobilepopup').style.display = 'none';

    document.getElementById('loadingfunction').style.visibility =  'hidden';

    setTimeout(function(){
      document.getElementById('loadingfunction').style.visibility = 'visible';
    },2400);

  //Ad Blocker

    window.onload = function(){
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.onreadystatechange = function() {
        if( xmlhttp.readyState == XMLHttpRequest.DONE ){
          if( xmlhttp.status !== 404 ){
              console.log("Blocking ads");
              document.getElementById('adBlockerDiv').style.display = 'block';

          }else{
              console.log("Not blocking ads");
          }
        }
      }
      xmlhttp.open("GET", "/498100ffe815d700cd838d1/ads/showad.js", true)
      xmlhttp.send();      
    }

  }

  public geturl(a){
      console.log(a);
      document.getElementById('mobilepopupmodal').setAttribute('src',a);
  }

  closepopup(){
    document.getElementById('mobilepopupmodal').style.display = 'none';
    document.getElementById('mobilepopupmodal').setAttribute('src','');
    document.getElementById('closemobilepopup').style.display = 'none';
    document.getElementById('main-body-id').style.opacity = '1';
    document.getElementById('header-id').style.opacity = '1';
    document.getElementById('footer-id').style.opacity = '1';
  }
  
}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/app.component.ts